export const trackingEventPartUpdate = "part_update";
/**
 * These are the valid actions for the trackingEventCopilotCredits event
 *
 * Use e.g. keyof typeof trackingActionsForCopilotCredits when typing against this
 */
export const trackingEventActionsForPartUpdate = {
    // Frontend actions
    startReceivingLatestDrafts: "startReceivingLatestDrafts",
    stopReceivingLatestDrafts: "stopReceivingLatestDrafts",
    draftUpdateReceived: "draftUpdateReceived",
    partUpdateApplied: "partUpdateApplied",
};
//# sourceMappingURL=partUpdate.js.map